import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import viConfig from '../lang/vi.json';
import enConfig from '../lang/en.json';

const resources = {
    en: {
        translation: enConfig
    },
    vi: {
        translation: viConfig
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: 'vi',
        fallbackLng: 'vi',
        interpolation: {
            escapeValue: false
        }
    })
